import template from './loansDetailSendDocumentation.html';
import './loansDetailSendDocumentation.scss';

let loansDetailSendDocumentationComponent = {
  restrict: 'E',
  bindings: {
    loan: '<',
    serviceClosed: '<',
    isMobileApp: '<'
  },
  template,
};

export default loansDetailSendDocumentationComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailSendDocumentation/loansDetailSendDocumentation.component.js